import { LanguageCodeValues } from '@Common/types/language';

export const languageChoices = LanguageCodeValues.map((languageCode) => ({
  id: languageCode,
  name: `resources.bo_common.b2b.employees.choices.language.${languageCode.toLocaleLowerCase()}`,
}));
